import actions from './TripSearch.actions.js';
import getters from './TripSearch.getters.js';
import mutations from './TripSearch.mutations.js';
import state from './TripSearch.state.js';

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
};